import "@/translations";
import { FC, Suspense, lazy } from "react";
import { BrowserRouter } from "react-router-dom";
import { useAppSelector } from "./store";
import { getIsAuthenticated } from "./store/auth/slice";
import { useTranslation, I18nextProvider } from "react-i18next";
import Paper from "@mui/material/Paper";

const UnauthenticatedLayout = lazy(() => import("./components/UnauthenticatedLayout"));
const AuthenticatedLayout = lazy(() => import("./components/AuthenticatedLayout"));

const App: FC = (): JSX.Element => {
    const { i18n } = useTranslation();
    const authenticated = useAppSelector(getIsAuthenticated);

    return (
        <I18nextProvider i18n={i18n}>
            <BrowserRouter>
                <Suspense>
                    <Paper elevation={0} square sx={{ height: "100%" }}>
                        {!authenticated && <UnauthenticatedLayout />}
                        {authenticated && <AuthenticatedLayout />}
                    </Paper>
                </Suspense>
            </BrowserRouter>
        </I18nextProvider>
    );
};

export default App;
